import { createValidator } from "not-valid";

const LETTERS_REGEX = /^[a-zA-Z]+$/i;
const VALID_LETTERS_ONLY = "Please use only letters";

export const validLettersOnly = (message?: string) => {
    return createValidator<string>((value: string) => {

        return LETTERS_REGEX.test(value);
    },
    message || VALID_LETTERS_ONLY);
};
